<template>
    <div class="col-md-12 panel">
                <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>
                <div class="row">
                    <div class="col-md-12">
                        <div class="panel">
                            <div class="panel-heading">
                                <div class="panel-title hidden-xs">
                                    <span class="glyphicon glyphicon-tasks"></span>Клиенты по источникам <span
                                        id="instructor_name"></span></div>
                            </div>
                            <form v-on:submit.prevent="getReport" class="ng-pristine ng-valid">
                                <div class="panel-body ">
                                    <div class="col-md-4">
                                        <select :disabled="isLoading" v-model="filter.source" class="form-control">
                                            <option v-for="source in sources" v-bind:key="source.id" :value="source.id">
                                                {{source.name}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.from" class="form-control"  :disabled="isLoading"
                                               value="" placeholder="Начало периода" required="">
                                    </div>
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.to" class="form-control"  :disabled="isLoading"
                                               value="" placeholder="Конец периода" required="">
                                    </div>

                                </div>
                                <div class="panel-footer">
                                    <button type="submit" class="btn btn-primary getstat mr20"> Показать </button>
                                    <button type="button" class="btn btn-success" @click="getXlsx">Скачать Xlsx</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="section row" v-if="rows.length > 0">
                    <div class="col-md-12">
                        <div class="panel panel-visible">

                            <div class="panel-body pn">
                                <table class="table table-striped table-hover datatables table-fixed-header" cellspacing="0" width="100%">
                                    <thead>
                                    <tr>
                                        <th>ФИО</th>
                                        <th>Источник</th>
                                        <th>Телефон</th>
                                        <th>Дата создания</th>
                                        <th>Потратил, руб</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in rows" v-bind:key="index">
                                        <td>{{row.name}}</td>
                                        <td>{{row.source}}</td>
                                        <td>{{row.phone}}</td>
                                        <td>{{row.created}}</td>
                                        <td>{{row.sum}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

    </div>
</template>

<script>
    import Report from "../../classes/api/Report";
    import moment from 'moment';
    import Client from '../../models/Client'
    import FileDownload from 'js-file-download'

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
        },
        mounted() {
            this.getReport();
        },
        data() {
            return {
                isLoading: false,
                sources: [{id: 0, name: 'Все источники'}, ...Client.getSources()],
                filter: {
                    from: moment().format('YYYY-MM-01'),
                    to: moment().format('YYYY-MM-DD'),
                    source: 0,
                },
                rows: [],
            };
        },
        methods: {
            async getReport() {
                this.isLoading = true;
                let response = await Report.getClientBySource(this.filter.from, this.filter.to, this.filter.source);
                this.rows = response.data;
                this.isLoading = false;
            },
            getXlsx() {
                Report.getClientBySource(this.filter.from, this.filter.to, this.filter.source, true).then(response => {
                    FileDownload(response.data, 'Клиенты по источникам.xlsx')
                });
            },
        },
        metaInfo() {
            return {
                title: 'Отчеты - клиенты по источникам',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
